/**
 * @generated SignedSource<<4096a5d2e39e841cb09be08877b8d74e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VFolderNodesFragment$data = ReadonlyArray<{
  readonly group: string | null | undefined;
  readonly host: string | null | undefined;
  readonly id: string;
  readonly name: string | null | undefined;
  readonly ownership_type: string | null | undefined;
  readonly permissions: ReadonlyArray<any | null | undefined> | null | undefined;
  readonly status: string | null | undefined;
  readonly usage_mode: string | null | undefined;
  readonly user: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BAINodeNotificationItemFragment" | "BAIVFolderDeleteButtonFragment" | "EditableVFolderNameFragment" | "SharedFolderPermissionInfoModalFragment" | "VFolderNodeIdenticonFragment" | "VFolderPermissionCellFragment">;
  readonly " $fragmentType": "VFolderNodesFragment";
} | null | undefined>;
export type VFolderNodesFragment$key = ReadonlyArray<{
  readonly " $data"?: VFolderNodesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VFolderNodesFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "VFolderNodesFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      "action": "NONE"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "host",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownership_type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "user",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "group",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usage_mode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VFolderPermissionCellFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditableVFolderNameFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VFolderNodeIdenticonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFolderPermissionInfoModalFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BAIVFolderDeleteButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BAINodeNotificationItemFragment"
    }
  ],
  "type": "VirtualFolderNode",
  "abstractKey": null
};

(node as any).hash = "fc29538de9d07bf8ccb44424f3dbbe0c";

export default node;
